import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AppBreadcrumbService } from '../app.breadcrumb.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { min } from 'rxjs/operators';
import { utility } from '../common/utility';
import { AccountService } from '../services/AccountService';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {      
    initdata: any[];
    news: any[];
    sponsors: any[];
    advertisements: any[];
    rowsPerPageOptions: number[] = utility.RowsPerPageOptions;
    isAdmin: boolean = false;
    canAddNews: boolean = false;
    responsiveOptions = [
        {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
        },
        {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 2
        },
        {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
        }
      ];

    constructor(private activatedRoute: ActivatedRoute,
        private breadcrumbService: AppBreadcrumbService,
        private accountService: AccountService,) {
        this.breadcrumbService.setItems([
            this.breadcrumbService.news,
        ]);        
    }

    ngOnInit() {     
        this.isAdmin = this.accountService.IsAdmin;
         this.initdata = this.activatedRoute.snapshot.data['data'];
         this.news = this.initdata[0];
         this.advertisements = this.initdata[1];
        this.sponsors = this.initdata[2];
        this.canAddNews = this.accountService.CanAddNews();
    }

    getImageURL(res: any) : string 
    {
        var result = environment.imageBase.concat(res.Documents[0].DocumentURI);

        return result; 
    }

    getBrandAdvertImage(index:any): string
    {
        var res = this.advertisements[index];               
        var imageurl: string;

        if(res != null && res.Documents!= null)
        {
            res.Documents.forEach(element => {

                if(element.FileTypeID != 7)
                {
                    imageurl = environment.imageBase.concat(element.DocumentURI);
                }
                
            });
        }
        
        return imageurl; 

    }
    getBrandAdvertUrl(index:any): string
    {
        var res = this.advertisements[index];               
        
        var adurl: string;

        if(res != null && res.Documents!= null)
        {
            res.Documents.forEach(element => {

                if(element.FileTypeID == 7)
                {
                    adurl = element.DocumentURI;
                }
                
            });
        }
        
        return adurl; 
    }
    removeHTML(str){ 
        var tmp = document.createElement("DIV");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
    }

    getStatusbadge(categoryid:any): string
    {
        var statusbadge = 'gold';

        switch (categoryid) {
            case 72:
                statusbadge = 'platinum';
                break; 
            case 73:
                statusbadge = 'gold';
                break; 
            case 74:
                statusbadge = 'bronze';
                break; 
            case 75:                
                statusbadge = 'Exhibitors';
                break; 
            
          }
        
        return statusbadge;

    }

}
